<template>
  <div
    :class="'calendar-content-warning-item calendar-content-warning-item-' + level"
    :style="getWarningPositionCss"
    :title="warningData.message">
    <small class="warning-reference-name">
      <i class="material-icons">{{ icon }}</i>
      {{ warningData.reference_name }}
    </small>
    <span class="warning-message">
      {{ warningData.message }}
    </span>

    <div
      class="calendar-content-warning-item-tooltip"
      :style="getTooltipPositionCss">
      <strong class="calendar-content-warning-item-tooltip-type">
        <i class="material-icons">{{ icon }}</i>
        {{ warningData.reference_name }}
      </strong>

      <small class="calendar-content-warning-item-tooltip-time">
        <span>
          {{ warningData.valid_from | displayDateTime }}
        </span>
        <span v-if="warningData.valid_to">
          - {{ warningData.valid_to | displayDateTime }}
        </span>
      </small>

      <div class="calendar-content-warning-item-tooltip-description">
        {{ warningData.message }}
      </div>
    </div>
  </div>
</template>

<script>
import DateUtils from './../../utils/DateUtils.js';

export default {
  name: 'calendar-warning-item',
  props: [
    'dateFrom',
    'dateTo',
    'level',
    'warningData'
  ],
  filters: {
    displayDateTime (value) {
      if (value) {
        let input = new Date(value);
        let date = [
          input.getDate(),
          DateUtils.getMonthShortName(input.getMonth() + 1),
          input.getFullYear().toString().substr(2, 2)
        ].map(n => n < 10 ? '0' + n : n).join('');

        value = value.split(' ')[1];
        value = value.split(':');
        let time = [value[0], value[1]].join('');

        return date + ' ' + time;
      }

      return '';
    }
  },
  computed: {
    icon () {
      switch (this.warningData.reference_type) {
        case 'AIRCRAFT': return 'local_airport';
        case 'AIRPORT': return 'flight_takeoff';
        case 'COUNTRY': return 'language';
        case 'CREW': return 'face';
        case 'CUSTOMER': return 'work';
        case 'HOTEL': return 'local_hotel';
        case 'PASSENGER': return 'airline_seat_recline_normal';
        default: return 'warning';
      }
    },
    getWarningPosition () {
      let validFrom = new Date(this.warningData.valid_from);
      let validTo = new Date(this.warningData.valid_to);
      let rangeFrom = new Date(this.dateFrom);
      let rangeTo = new Date(this.dateTo);
      let left = 0;
      let right = 0;

      if (this.warningData.valid_to === null) {
        validTo = rangeTo;
      }

      if (validFrom > rangeFrom) {
        let diff = validFrom - rangeFrom;
        left = (diff / (rangeTo - rangeFrom)) * 100;
      }

      if (validTo < rangeTo) {
        let diff = rangeTo - validTo;
        right = (diff / (rangeTo - rangeFrom)) * 100;
      }

      return {
        left,
        right,
        width: 100 - left - right
      };
    },
    percentageTooltipHalfWidth () {
      return ((320 / document.querySelector('.calendar-content').offsetWidth) / 2) * 100.0;
    },
    getWarningPositionCss () {
      let position = this.getWarningPosition;
      return 'left: ' + position.left + '%;right: ' + position.right + '%;';
    },
    getTooltipPositionCss () {
      let position = this.getWarningPosition;
      let left = parseFloat(position.left + (position.width / 2));

      if (left - this.percentageTooltipHalfWidth < 0) {
        return 'left: 0%!important; transform: none;';
      }

      if (left + this.percentageTooltipHalfWidth > 100) {
        return 'left: auto!important; right: 0%!important; transform: none;';
      }

      return '';
    },
  }
}
</script>

<style lang="scss" scoped>
.calendar-content-warning {
  &-item {
    bottom: 8px;
    color: #fff;
    cursor: help;
    font-size: 12px;
    height: 36px;
    padding: 3px 5px;
    position: absolute;
    text-align: center;
    top: 8px;

    &-high {
      background: var(--danger);
    }

    &-medium {
      background: var(--warning);
    }

    &-low {
      background: var(--secondary);
    }

    .warning-reference-name {
      display: block;
      font-size: 12px;
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;

      .material-icons {
        transform: scale(1.2);
      }
    }

    .warning-message {
      display: block;
      font-size: 14px;
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }

  &-item-tooltip {
    background: var(--secondary);
    border: 1px solid var(--light);
    border-radius: 4px;
    box-shadow: 0 5px 3px rgba(0, 0, 0, .125);
    color: var(--light);
    display: none;
    font-size: 14px;
    font-weight: 300;
    left: 50%;
    padding: 10px 15px;
    pointer-events: none;
    position: absolute;
    right: auto!important;
    top: 100%;
    transform: translateX(-50%);
    width: 320px;
    z-index: 1000;

    &-time {
      display: block;
      margin: 5px 10px;
      width: 100%;
    }
  }

  &-item:hover {
    .calendar-content-warning-item-tooltip {
      display: block;
    }
  }
}
</style>
